import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { LoadMoreStoriesBase } from "@quintype/components";
import { WebEngage, ComScore, DeepBI, GA, Chartbeat } from "../../../integrations";
import { LoadMoreButton } from "../../atoms/read-more-link";
import StoryCardML4x3DP1x1 from "../../atoms/story-card-ml4x3-dl1x1";
import { SpecialTopicPage } from "../special-topic-page";
import { DfpAd } from "../../atoms/dfp-ad";
import { FIELDS_FOR_LISTING_PAGE, PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
const StoryList = ({ stories }) =>
  stories.length > 0 ? (
    <React.Fragment>
      {stories.map(story => {
        return <StoryCardML4x3DP1x1 story={story} key={story.id} className={styles["story-card"]} />;
      })}
    </React.Fragment>
  ) : (
    <h3 className={styles["no-results"]}>No results found</h3>
  );

StoryList.propTypes = {
  stories: PropTypes.arrayOf(StoryCardML4x3DP1x1.propTypes.story)
};

const StoryListBase = ({ stories, loading, onLoadMore, noMoreStories }) => (
  <React.Fragment>
    <StoryList stories={stories} />
    {!noMoreStories &&
      stories.length >= 12 && (
        <div className={styles["load-more-wrap"]}>
          <LoadMoreButton text={loading ? "LOADING..." : " மேலும் படிக்க"} disabled={loading} onClick={onLoadMore} />
        </div>
      )}
  </React.Fragment>
);

export { StoryListBase };

StoryListBase.propTypes = {
  stories: PropTypes.arrayOf(StoryCardML4x3DP1x1.propTypes.story),
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func,
  noMoreStories: PropTypes.bool
};

const TagPage = ({ data }) => {
  if (data.entity) {
    return <SpecialTopicPage data={data} />;
  }
  React.useEffect(() => {
    WebEngage.registerPageView();
    ComScore.registerPageView();
    DeepBI.loadScript();
    GA.registerPageView(PAGE_TYPE.TOPIC_PAGE, {});
    Chartbeat.registerNonStoryPageView(PAGE_TYPE.TAG_PAGE, { tag: get(data, ["tag"], {}) });
  }, []);

  const tagName = get(data, ["tag", "name"], null);
  const tagSlug = get(data, ["tag", "slug"], null);

  return (
    <div className={`main-page ${styles["base-container"]}`}>
      <DfpAd className="hidden-mobile ad-tower-left" adtype="Tower_Left" placement="all" />
      <div className={styles.base}>
        <div className={`container`}>
          {tagName && <h1 className={styles.headline}>#{tagName}</h1>}
          <div className={`row`}>
            <LoadMoreStoriesBase
              template={StoryListBase}
              numStoriesToLoad={9}
              data={data}
              params={{ "tag-slugs": tagSlug }}
              fields={FIELDS_FOR_LISTING_PAGE}
            />
          </div>
        </div>
        <DfpAd adtype="Leaderboard" placement="tag-page" />
      </div>
      <DfpAd className="hidden-mobile ad-tower-right" adtype="Tower_Right" placement="all" />
    </div>
  );
};

export { TagPage };

TagPage.propTypes = {
  data: PropTypes.shape({
    tag: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string
    }),
    stories: PropTypes.arrayOf(StoryCardML4x3DP1x1.propTypes.story)
  })
};
